'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { toggleSiteScroll } from '@/lib/utils';
import { lenis } from '@/app/components/common/SmoothScroll/SmoothScroll';

const ModalContext = createContext(undefined);

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [buttonDataFields, setButtonDataFields] = useState({});

  const openModal = (content, fields = {}) => {
    setModalContent(content);
    setIsOpen(true);
    setButtonDataFields(fields);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalContent(null);
    setButtonDataFields({});
  };

  useEffect(() => {
    toggleSiteScroll(isOpen || isSuccessOpen);
  }, [isOpen, isSuccessOpen]);

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        isOpen,
        setIsOpen,
        isSuccessOpen,
        setIsSuccessOpen,
        buttonDataFields,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
